import Cookies from 'js-cookie'
;(function($) {
    'use strict'

    window.PHI = window.PHI || {}

    PHI.DATE_FORMAT = 'YYYY-MM-DD'
    PHI.FILTER_MIN_DATE = new Date(2012, 0, 1)
    PHI.TITLE_MAX_WORDS = 12
    PHI.SHORT_DESCRIPTION_MAX_WORDS = 25

    PHI.validate_date = function(d) {
        return moment(d, PHI.DATE_FORMAT, true).isValid()
    }

    // validate a date text box with momentjs
    $.fn.validateDate = function() {
        return PHI.validate_date($(this).val())
    }

    PHI.get_title = function(item) {
        if (item.short_title) return item.short_title

        return item.title.ellipsify(PHI.TITLE_MAX_WORDS)
    }

    PHI.get_short_description = function(item) {
        if (!item.short_description) return ''

        return item.short_description.ellipsify(PHI.SHORT_DESCRIPTION_MAX_WORDS)
    }

    function _toggleNavigation(e) {
        e.preventDefault()

        var nav = $('.main-nav-container'),
            content = $('.site-content-container'),
            expandButton = $('.nav-expand'),
            collapseButton = $('.nav-collapse')

        if (nav.hasClass('main-nav-container--collapsed')) {
            nav.removeClass('main-nav-container--collapsed')
            content.removeClass('site-content-container--nav-collapsed')
            expandButton.hide()
            collapseButton.show()
        } else {
            nav.addClass('main-nav-container--collapsed')
            content.addClass('site-content-container--nav-collapsed')
            expandButton.show()
            collapseButton.hide()
        }

        return false
    }

    function _toggleChildrenMenu(e) {
        var clickedMenuItem = $(this),
            parentListItem = clickedMenuItem.parent('li'),
            subMenu = parentListItem.find('ul.sub-menu')

        // console.log('PARENT',parentListItem);

        if (subMenu.length > 0) {
            e.preventDefault()

            if (subMenu.hasClass('is-active')) {
                parentListItem.removeClass('is-active')
                subMenu.removeClass('is-active').css({
                    height: '0',
                    'margin-top': '0'
                })
            } else {
                var listItems = subMenu.find('li'),
                    otherParentListItems = parentListItem.siblings('li'),
                    totalHeight = 0
                // console.log('LIST ITEMS', listItems);
                $.each(otherParentListItems, function() {
                    var otherParentListItem = $(this),
                        otherSubMenu = otherParentListItem.find('ul.sub-menu')
                    otherParentListItem.removeClass('is-active')
                    otherSubMenu.removeClass('is-active').css({
                        height: '0',
                        'margin-top': '0'
                    })
                })

                $.each(listItems, function() {
                    // console.log('HEIGHT', $(this).find('a').text(),$(this).outerHeight());
                    totalHeight = totalHeight + $(this).outerHeight()
                })

                parentListItem.addClass('is-active')
                subMenu.addClass('is-active').css({
                    height: totalHeight + 'px',
                    'margin-top': '10px'
                })
            }
            // Check for height
            // setTimeout( function() {
            //     _sidebarScrollsDetection();
            // }, 500);
        } // End if has subMenu
    }

    function _toggleNavigationResize() {
        var $window = $(window),
            windowWidth = $window.outerWidth(true),
            nav = $('.main-nav-container'),
            expandButton = $('.nav-expand'),
            collapseButton = $('.nav-collapse'),
            content = $('.site-content-container'),
            mobileWidthThreshold = 1200

        if (windowWidth <= mobileWidthThreshold) {
            nav.addClass('main-nav-container--collapsed')
            content.addClass('site-content-container--nav-collapsed')
            expandButton.show()
            collapseButton.hide()
        } else if (windowWidth > mobileWidthThreshold) {
            nav.removeClass('main-nav-container--collapsed')
            content.removeClass('site-content-container--nav-collapsed')
            expandButton.hide()
            collapseButton.show()
        }
    }

    function _sidebarScrollsDetection() {
        var navSidebar = $('.main-nav-container .main-nav-menus'),
            navSidebarHeight = navSidebar.height(),
            navSidebarRuler = $('.main-nav-container .main-nav-menus-ruler'),
            navSidebarRulerHeight = navSidebarRuler.height()

        if (navSidebarHeight < navSidebarRulerHeight) {
            navSidebar.addClass('is-scrolling')
        } else {
            navSidebar.removeClass('is-scrolling')
        }
    }

    function _sidebarScrollButtons() {
        var sidebarMenuScrollButtonUp = $('.scroll-me button.scroll-up'),
            sidebarMenuScrollButtonDown = $('.scroll-me button.scroll-down'),
            sidebarMenu = $('.main-nav-container .main-nav-menus')

        sidebarMenuScrollButtonUp.on({
            'mousedown touchstart': function() {
                sidebarMenu.animate(
                    {
                        scrollTop: 0
                    },
                    2000
                )
            },
            'mouseup touchend': function() {
                sidebarMenu.stop(true)
            }
        })

        sidebarMenuScrollButtonDown.on({
            'mousedown touchstart': function() {
                sidebarMenu.animate(
                    {
                        scrollTop: sidebarMenu[0].scrollHeight
                    },
                    2000
                )
            },
            'mouseup touchend': function() {
                sidebarMenu.stop(true)
            }
        })
    }

    function _setup_dropdowns() {
        $('#hub-page-filter-expert-expertise')
            .select2()
            .next()
            .css('width', 'auto')

        $('.hub-page-policy .filter-resources select').select2()

        $('.list-page-filter select').select2()

        $('.wpcf7 select').select2()

        $('.list-page-filter-more-toggle a').click(function(e) {
            e.preventDefault()

            var t = $(this),
                exp = t.hasClass('list-page-filter-more-toggle--expanded')

            if (exp) {
                $('.list-page-filter-more').hide()
                t.removeClass('list-page-filter-more-toggle--expanded')
            } else {
                $('.list-page-filter-more').show()
                t.addClass('list-page-filter-more-toggle--expanded')
            }
        })

        $('.search-modal-filter-more-toggle a').click(function(e) {
            e.preventDefault()

            var t = $(this),
                exp = t.hasClass('search-modal-filter-more-toggle--expanded')

            if (exp) {
                $('.search-modal-filter-more').hide()
                t.removeClass('search-modal-filter-more-toggle--expanded')
            } else {
                $('.search-modal-filter-more').show()
                t.addClass('search-modal-filter-more-toggle--expanded')
            }
        })
    }

    function _setup_date_pickers() {
        $('.list-page-filter-date').pikaday({
            format: PHI.DATE_FORMAT,
            firstDay: 1,
            minDate: PHI.FILTER_MIN_DATE,
            maxDate: new Date(),
            yearRange: [
                PHI.FILTER_MIN_DATE.getFullYear(),
                new Date().getFullYear()
            ]
        })
    }

    function _setup_donate_buttons() {
        // passed via `wp_localize_script()` as JSON-encoded string
        const donateLink = phi_theme.global_donate_link;

        if ( ! donateLink.url ) return;

        // dynamically update all donate links
        //
        // decided not to update inner text, just in
        // case it inadvertantly overwrites some HTML
        $('.donate-button, a[href$="#donate"]')
            .attr('href', donateLink.url)
            .attr('target', donateLink.target);
    }

    function _setup_outbound_target() {
        $.each($('a'), function(i, v) {
            if (
                v.hostname &&
                v.hostname !== '#' &&
                v.hostname !== window.location.hostname
            ) {
                // make sure external links open in a new window, and mitigate
                // tabnabbing
                $(v)
                    .prop('target', '_blank')
                    .prop('rel', 'noopener')
            }
        })
    }

    function _setup_nice_quoted() {
        var haveAny = false

        $.each($('.detail-page-content__body-content p'), function(i, v) {
            var me = $(v)

            if (/^["“]/.test(me.text())) {
                me.addClass('starts-with-quote')
                haveAny = true
            }
        })

        if (haveAny) {
            $('.detail-page-content__body')
                .css('overflow', 'visible')
                .parent()
                .css('overflow', 'visible')
        }
    }

    $(function() {
        $('a.nav-collapse, a.nav-expand').click(_toggleNavigation)

        $('div.main-nav-menus li a').click(_toggleChildrenMenu)

        _toggleNavigationResize()
        // _sidebarScrollsDetection();
        // _sidebarScrollButtons();

        _setup_dropdowns()
        _setup_date_pickers()
        _setup_donate_buttons()
        _setup_nice_quoted()
        _setup_outbound_target()

        // track outbound links
        $('a').click(PHI.google.trackOutbound)
    })

    $(document).ready(function() {
        // Keep transitions from running before doc is ready
        $('body').addClass('animation-ready')
        if (!getCookie('STYXKEY_subscribebar') && $('.subscribe-bar').length > 0)
        {
            $('body').addClass('show-subscribe-bar')
        }
        CONSTUTIL.utilities.constructiveEqualHeight()
    })

    $(window).resize(function() {
        _toggleNavigationResize()
        _sidebarScrollsDetection();
        CONSTUTIL.utilities.constructiveEqualHeight()
    })

    function createCookie(name, value, days) {
        const domains = [
            '172.28.128.3',
            'dev-phinew.pantheonsite.io',
            'test-phinew.pantheonsite.io',
            'live-phinew.pantheonsite.io',
            'phinew.test',
            'phinational.org'
        ]
        for (var i = 0; i < domains.length; i++) {
            if (days) {
                var date = new Date()
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
                var expires = '; expires=' + date.toGMTString()
            } else var expires = ''
            document.cookie =
                name + '=' + value + expires + '; path=/; domain=' + domains[i]
        }
    }

    function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) return null;
        }
        else
        {
            begin += 2;
            var end = document.cookie.indexOf(";", begin);
            if (end == -1) {
            end = dc.length;
            }
        }
        // because unescape has been deprecated, replaced with decodeURI
        //return unescape(dc.substring(begin + prefix.length, end));
        return decodeURI(dc.substring(begin + prefix.length, end));
    }

    function hideSubscribeBar() {
        $('body').removeClass('show-subscribe-bar')
    }

    $('.subscribe-bar__close').click(function() {
        createCookie('STYXKEY_subscribebar', 'seen', '14')
        hideSubscribeBar()
    })
})(jQuery)
